import { call, put, select, takeLatest } from 'redux-saga/effects';
import { DISCARD_FROM_PLAY, LOOK } from './constants';
import { endDiscardFromPlay, endLook } from './actions';
import gameTurnService from '../services/gameTurn';
import { handleUpdateGame } from '../ActiveGame/sagas';
import { selectActiveGame } from '../ActiveGame/selectors';
import { closeContextMenu } from '../ActiveGame/actions';

function* lookTask(action) {
  const gameId = (yield select(selectActiveGame)).get('id');

  try {
    const game = yield call(gameTurnService.look, gameId, action.payload.get('deckPositions').toArray());
    yield call(handleUpdateGame, game);
  } finally {
    yield put(endLook());
  }
}

function* discardFromPlayTask(action) {
  const gameId = (yield select(selectActiveGame)).get('id');

  try {
    const game = yield call(gameTurnService.discardFromPlay, gameId, action.payload.get('at'));
    yield call(handleUpdateGame, game);
    yield put(closeContextMenu());
  } finally {
    yield put(endDiscardFromPlay());
  }
}

function* discardFromPlayWatcher() {
  yield takeLatest(DISCARD_FROM_PLAY, discardFromPlayTask);
}

function* lookWatcher() {
  yield takeLatest(LOOK, lookTask);
}

export default [
  lookWatcher,
  discardFromPlayWatcher,
];
